<template>
<div id="msgList" >
<div class="msgListCountCon">
  <div class="clearAll" ><span  @click="clear()">清空</span></div>  
  <div class="contentRight">
    <div class="rightcon">     
      <el-card class="box-card" v-for="(item,index) in items" :key="index">
          <el-row>
            <el-col :span="24" class="subCOn">
              <div class="subject"><div class="subdot" v-show="!item.read"></div><span v-html="item.title">{{item.title}}</span></div>
              <!-- <div class="intro" v-if="$route.query.msgType==3" >开始时间：2018年8月2日 15:40</div> -->
            </el-col>
          </el-row>
          <el-row class="rowTow">
            <el-col :span="18" class="datetime">{{item.sendTime}}</el-col><el-col :span="6" ><a class="more floatRight" v-if="item.jumpUrl&&$route.query.msgType!=5" @click="detail(item)">查看详细</a></el-col>
          </el-row>
        <!-- <div slot="header" class="clearfix">
          <span>卡片名称</span>
        </div> -->
        <!-- <div v-for="o in 2" :key="o" class="text item">
          {{'列表内容 ' + o }}
        </div> -->
      </el-card>
      <div  v-infinite-scroll="loadMore" infinite-scroll-disabled="busy" infinite-scroll-distance="10">
        <!-- <span v-show="loadingShow">加载中</span> -->
        <div v-show="loadingShow" class="loading">
          <div class="demo0">加载中</div>
          <div  id="loading1">
              <div class="demo1"></div>
              <div class="demo1"></div>
              <div class="demo1"></div>
              <div class="demo1"></div>
              <div class="demo1"></div>
          </div>
        </div>

      </div>
      <el-row>
        <el-col :span="24" class="nodata" v-show="nodata">暂无数据</el-col>
      </el-row>
      <div v-show="line" class="line">
      <span>我是有底线的</span>
      </div>
      <el-row >
        <!-- v-if="total>10" -->
        <!-- <el-col :span="24" class="pagesize pages" >
          <el-pagination
            @current-change="handleCurrentChange"
            :page-size= "pageSize"
            layout="total, prev, pager, next, jumper"
            :total="total">
          </el-pagination>
        </el-col> -->  
      </el-row>
    </div>  
          
  </div>
  

</div>

</div>
</template>
<script>
import url from '@/modules/url'
import api from '@/modules/api'

export default {
  name:'Msglist',
  components: {    
  },
  data () {
    return {
     pageSize: 10,
     currentPage: 1,
     total:0,
     items:[],
     countDown:'',
     busy: true, //是否正在加载过程中,true为繁忙的时候不执行loadMore,false则执行
     loadingShow:false,//是否显示加载中提示文字
     line:false,
     nodata:false
    }
  },
  methods: {
    handleOpen(key, keyPath) {
      console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath);
    },
    handleCurrentChange (val) {
      this.currentPage = val
      console.log(this.currentPage)
      this.items=[]
      this.getMessage()
    },
    loadMore () {
      // this.currentPage++
      this.busy = true;
      // 多次加载数据
      setTimeout(() => {
          this.currentPage ++;
          this.getMessage(true);
      }, 1000);
    },
    changetime (data) {
      let getDate = new Date(data)
      let y = getDate.getFullYear()
      let M = getDate.getMonth() + 1
      let d = getDate.getDate()
      let format = y + '-' + M + '-' + d
      return format
    },
    getMessage(flag){
      let that = this      
      let options = {
        msgType:that.$route.query.msgType,
        currentPage:that.currentPage,
        pageSize:10
      }
      api.post(that.$url.getMessage,options,(res)=>{
        console.log(res,'所有数据')
        if(res.result.isSuccess){
          
          that.total = res.data.total
          let data= res.data.list
          console.log('测试data',data)
           data.forEach(response => {
              // console.log(response.msgCode,'------------')
              // that.clearRead(response.msgCode)
              that.items.push(response)
              if(response.sendTime!==undefined){
                response.sendTime=response.sendTime
              }
            })
            // if(data.length!==0){
            //   that.line=true
            // }  
            if(flag){
            // 多次加载数据
              // this.items = this.items.concat(res.result.list);
              // data = data.concat(res.result.list)
              // alert(res.data.list.length)
              if(res.data.list.length == 0){
                  this.busy = true;
                  this.loadingShow = false
                  this.line = true
              }else{
                  this.busy = false;
                  this.loadingShow = true
                  this.line = false
              }
          }else{
              // 第一次加载数据
              if(res.data.list.length>=10){
                this.line = false
                this.loadingShow = true
                // 当第一次加载数据完之后，把这个滚动到底部的函数触发打开
                this.busy = false;
              }else{//小于10条数据不滚动加载busy设为true
              // 当第一次加载数据完之后，把这个滚动到底部的函数触发打开
                this.busy = true;
                this.line = true
                this.loadingShow = false
                

              }
              
             
          }  
        
        // if (that.items.length < Number(res.data.total)) {
        //         console.log(that.items.length)
        //         console.log( Number(res.data.total))
        //         that.loading = false
        //         that.finished = false      
        //       } else {
        //         that.finished = true
        //         that.loading = false
        //       }
              if(res.data.total == '0'){
                this.nodata = true
                this.line= false
                // this.$toast.message("没有查到数据")
              }
            
        }else{
              that.line=false
              // that.$toast.message('出错了!')
              this.$message({
                message: '出错了!',
                type: 'warning'
              })
              that.loadingShow = true
            }
        
      })
    },
    clear(){
      let that = this
      if(!that.nodata){
        that.$confirm('此操作将清除当前所有消息, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          api.post(that.$url.clear,{msgType:that.$route.query.msgType},(res)=>{
            if(res.result.isSuccess===true){
                that.items=[]
                that.line=false
                that.$message({
                  message: '恭喜您清除成功!',
                  type: 'success',
                  customClass:'msgTips',
                  center: true
                })
                that.getMessage(false)
            }
          })
        }).catch(() => {
          that.$message({
            type: 'info',
            message: '已取消删除'
          });          
        });
      }else{
              that.$message({
                message: '没有可清除的数据了!',
                type: 'error',
                customClass:'msgTips',
                center: true
              })
            }
    },
    detail(item){
      let that = this
      let msgCode = item.msgCode
      api.post(that.$url.tabRead,{msgCode:msgCode},(res)=>{
        item.read=true
        that.getMessage(false)
      })
      // window.location.href=item.jumpUrl
      if(item.jumpUrl==""){
        that.$router.push({name:'detail',query:{id: item.businessNo}})
      }else{
        window.open(item.jumpUrl)
      }
      
    }
  },
  mounted () {
    // alert(1)
    this.getMessage(false)
  },
  watch:{
    $route(to,from){
      console.log(to)
      this.items=[]
      this.total=0
      this.line = false
      this.loadingShow = false
      this.nodata = false
      this.currentPage=1
      this.getMessage(false)
      // if(this.countDown){
      //     clearInterval(this.countDown);
      // }
      // this.countDown = setTimeout (()=>{
      //     // tooltips.classList.remove('active')
      //     // this.commentminus = ''
      //     this.clearRead()
      // }, 1000)

      
    }
    
  }
}
</script>

<style scoped>
.body{
    font-family:"Microsoft YaHei";
    font-size: 19px;
    /* background: #fff; */
    width:100%;
    min-height: 100%;
    /* overflow-x: hidden; */
}
#msgList{
  /* padding-top: 60px; */
  height: 100%;
  box-sizing: border-box;
}
.msgListCountCon{
  /* overflow: hidden; */
  /* min-height: 100%; */
  width: 100%;
  margin:0 auto;
  height:100%;
  box-sizing: border-box;
  -webkit-box-sizing: border-box;
}
.menuLeft{
  width:14%;
  float: left;
  height: 100%;
  background: #ffffff;
}
.clearAll{
  text-align: right;
  height: 40px;
  line-height: 40px;
  padding-right: 40px;
  padding-top: 20px;
  color: #3D62AD;
  font-size: 16px;
  font-weight: bold;
  /* position: fixed;  */
  /* right: 70px; */
}
.clearAll span{
  cursor: pointer;
}

.contentRight{
  width:94%;
  margin: 0 auto;
  /* float: left; */
  /* padding-top: 20px; */
  position: relative;
  /* min-height: 100%; */
  min-height: calc(100% - 60px);
  padding-top: 10px;
  padding-bottom: 30px;
  box-sizing: border-box;
}

.rightcon{
  width: 96%;
  margin: 0 auto;
}
.box-card{margin-bottom: 30px;}
.el-card.is-always-shadow, .el-card.is-hover-shadow:focus, .el-card.is-hover-shadow:hover{
  box-shadow: 0px 0px 10px 0px rgba(143,168,184,0.3);
}
.subCOn{
  border-bottom:1px solid #E5E5E5;
  min-height: 30px;
  line-height: 30px;
  padding-bottom: 15px;
}
.subject{
  /* padding:0px 15px; */
  position: relative;
  font-size: 16px;
}
.subject::first-line{
  font-size: 18px;
  /* line-height: 24px; */
}
.subject .subdot{
  display: inline-block; 
  width: 8px; 
  height: 8px; 
  border-radius:50%; 
  background:#3D62AD; 
  margin-right: 5px;
  /* position: absolute; 
  left:0px;
  top:50%;
  margin-top: -4px; */
  /* right:0; */
}
.intro{
  font-size: 14px;
  color: #111111;
}
.rowTow {
  height: 30px;
  line-height: 30px;
  padding:8px 0px 15px 0px;
  font-size: 14px;
}
.datetime{
  color: #919191;  
}
.more{
  color:#3D62AD;
  cursor: pointer;
}


.line{
  width: 100%;
  margin: auto;
  margin-top: 20px;
  border-top:1px solid #E5E5E5;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
}
.line span{
  color: #E5E5E5;
  font-size: 12px;
  background:#fff;
  padding:0 2px;
  position: absolute;
  top:-8px;
}
/* .line hr{
  display: inline-block;
  width:36%;

  color: #E5E5E5;
  border-top: none;
  vertical-align: middle
} */

.nodata{
  color: #666;margin-top: 20px; text-align: center;
}
.load-more-normal {
    text-align: center;
    height: 60px;
    line-height: 60px;
  }

  .load-more-hide {
    height: 0;
  }

  .loading{
    height: 30px;
    line-height: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  /* #loading1{
    margin-top: 15px;
  } */
.demo0{color:#ccc;font-size: 14px; float: left; margin-right: 6px;}
  .demo1 {
    width: 4px;
    height: 4px;
    border-radius: 2px;
    background: #ccc;
    float: left;
    margin: 0 3px;
    animation: demo1 linear 1s infinite;
    -webkit-animation: demo1 linear 1s infinite;
}
.demo1:nth-child(1){
    animation-delay:0s;
}
.demo1:nth-child(2){
    animation-delay:0.15s;
}
.demo1:nth-child(3){
    animation-delay:0.3s;
}
.demo1:nth-child(4){
    animation-delay:0.45s;
}
.demo1:nth-child(5){
    animation-delay:0.6s;
}
@keyframes demo1 
{
    0%,60%,100% {transform: scale(1);}
    30% {transform: scale(2.5);}
}
@-webkit-keyframes demo1 
{
    0%,60%,100% {transform: scale(1);}
    30% {transform: scale(2.5);}
}


</style>
<style>
.msgTips{
  /* position: fixed; */
  /* right: 20%; */
  top:40%;
}
</style>



// WEBPACK FOOTER //
// src/pages/msg/Msglist.vue